import React, { Component } from 'react';
import { View } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';
import { SuggestionList, OPComponent, I18n, Utils, Navigation } from '../components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class SelectTimeZone extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      items: this.prepItems(props.timeZones),
    };
  }

  componentDidMount() {
    Utils.trackScreen('Calendar', 'TimeZone Picker');
  }

  prepItems = timeZones => {
    return timeZones.map(timeZone => {
      return {
        label: timeZone.name,
        id: timeZone.abbrev,
      };
    });
  };

  handleValue = ({ value, item }) => {
    // ignore text input, only accept selection from list
    if (!item) return;

    this.props.setSelected(item.id);
    const { componentId, asModal } = this.props;
    Navigation.closeScreen({ componentId, asModal });
  };

  render() {
    let selectedId = this.state.selectedId || this.props.selectedId;
    return (
      <View style={THEME.container}>
        <SuggestionList
          items={this.state.items}
          defaultValue={this.props.selectedId}
          onValue={this.handleValue}
          placeholderText={I18n.ac('search')}
        />
      </View>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    timeZones: state.entities.metaData.timeZones,
  };
}

export default connect(mapStateToProps)(SelectTimeZone);
